import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';

import './form-input.css';
import { Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';

const FormInput = ({
  control,
  errors,
  name,
  label,
  rules,
  type,
  inputRef,
}: {
  control: any;
  errors: any;
  name: string;
  label: string;
  rules?: any;
  type?: any;
  inputRef?: any;
}) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div className="p-field">
      <span className="p-float-label">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState }) => {
            return type === 'password' ? (
              <Password
                readOnly={!loaded}
                id={name + '-input'}
                {...field}
                className={classNames('w-full', {
                  'p-invalid': fieldState.invalid,
                })}
                toggleMask
                feedback={false}
              />
            ) : (
              <InputText
                id={name + '-input'}
                className={classNames('w-full', {
                  'p-invalid': fieldState.invalid,
                })}
                {...field}
                ref={inputRef}
              />
            );
          }}
        />
        <label htmlFor={name + '-input'}>{label}</label>
      </span>
      <div className="mx-4 ml-4 mb-4 pr-4 h-4 w-full text-right">
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <small className="p-error p-d-block">{message}</small>
          )}
        />
      </div>
    </div>
  );
};
export default FormInput;
